import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Seal',
  data() {
    return {
      imageUrl: '',
      //回显的图片
      ip: localStorage.getItem("ip"),
      form: {},
      //即将提交到数据库的保存数组
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      currentPage: 1,
      pageSize: 20,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      //渲染到页面上的数据

      rules: {
        sealName: [{
          required: true,
          message: '印章名不为空',
          trigger: 'blur'
        }]
      }
    };
  },
  created() {
    console.log(sessionStorage.getItem('userName'));
    this.load();
  },
  methods: {
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      request.get('/detection/querySealUrl').then(res => {
        console.log(res);
        if (res.code == "0") {
          for (let i = 0; i < res.data.length; i++) {
            this.src = res.data[i].sealUrl;
          }
        }

        // this.ticket = res;
        // this.total = this.ticket.length
        // this.getPageInfo()
      });
    },

    Submit(formName) {
      // this.form.roleId = this.selectvalue2
      console.log(this.form + "---form");
      console.log(this.form.sealUrl);
      if (this.form.sealUrl == null || this.form.sealUrl == undefined) {
        this.$message({
          type: 'info',
          message: '上传的印章为空！'
        });
        return false;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          request.get("/detection/saveSeal", {
            params: {
              sealName: this.form.sealName,
              sealUrl: this.form.sealUrl
            }
          }).then(res => {
            if (res.code === '0') {
              this.$message({
                type: 'success',
                message: '上传成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: '上传失败！'
              });
            }
            this.load();
          });
        } else {
          console.log('error submit!!');
          this.$message({
            type: 'error',
            message: '数据不正确,请重新输入!'
          });
          return false;
        }
      });
    },
    uploadSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(res);
      this.form.sealUrl = file.response.data;
      console.log(this.form.sealUrl);
      // this.url = res.data
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error('上传签名图片只能是 JPG 或者是 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传签名图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M || isPNG && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 张图片，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    }
  }
};